/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pol_Status_GrayInputs */

const en_pol_status_gray = /** @type {(inputs: Pol_Status_GrayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gray area`)
};

const id_pol_status_gray = /** @type {(inputs: Pol_Status_GrayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abu-abu`)
};

/**
* | output |
* | --- |
* | "Gray area" |
*
* @param {Pol_Status_GrayInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pol_status_gray = /** @type {((inputs?: Pol_Status_GrayInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pol_Status_GrayInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pol_status_gray(inputs)
	return en_pol_status_gray(inputs)
});